import { TPaginatedResponse } from './shared.interfaces';

/**
 * Normalizes API paginated responses to canonical TPaginatedResponse shape.
 * Maps `count` → `total`, derives `totalPages` if missing, supports domain keys (messages, items, etc.).
 */
export function normalizePaginatedResponse<T>(
  response: Record<string, unknown> & { data?: T[] },
  dataKey = 'data'
): TPaginatedResponse<T> {
  const items = (response[dataKey] ?? response.data ?? []) as T[];
  const total = (response.total ?? response.count ?? items.length) as number;
  const page = (response.page ?? 1) as number;
  const limit = (response.limit ?? 10) as number;
  return {
    data: Array.isArray(items) ? items : [],
    total,
    page,
    limit,
    totalPages: (response.totalPages as number) ?? (limit > 0 ? Math.ceil(total / limit) : 0),
  };
}
